import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './Component/About/About';
import Footer from './Component/Footer/Footer';
import Videos from './Component/LoadVIdeos/Video';
import Login from './Component/Login/Login';
import Signup from './Component/Login/Signup';
import Playlist from './Component/Playlist/Playlist';
import { SearchVideos } from './Component/SearchVideos/SearchVideos';
import Header from './Header/Header';
import Hero from './Hero/Hero';
import DisplayBlog from './Hero/WriteBlog/DisplayBlog';
import EditBlog from './Hero/WriteBlog/EditBlog';
import WriteBlog from './Hero/WriteBlog/WriteBlog';

function App() {

  return (
    <div className="bg-white">
      <Header></Header>
      <Routes>
        <Route path="/" element={<Hero></Hero>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/videos" element={<Videos></Videos>}></Route>
        <Route path="/playlist" element={<Playlist></Playlist>}></Route>
        <Route path="/blogs" element={<WriteBlog></WriteBlog>}></Route>
        <Route path="/blogs/:blogId" element={<DisplayBlog></DisplayBlog>}></Route>
        <Route path='/update/:updateId' element={<EditBlog></EditBlog>}></Route>
        <Route path="/searchVideo" element={<SearchVideos></SearchVideos>}>
          <Route path=':video' element={<SearchVideos></SearchVideos>}></Route>
        </Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/signup' element={<Signup></Signup>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
